import { forwardRef, type Ref, type SVGProps } from "react";

function SvgUserStarred(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg ref={ref} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 17" {...props}>
      <g clipPath="url(#a)">
        <path
          fill="currentColor"
          d="m12.667 1.236-.723 1.445-1.444.722 1.444.722.723 1.445.722-1.445 1.444-.722-1.444-.722zM9.833 7.07a1.833 1.833 0 1 1-3.666 0 1.833 1.833 0 0 1 3.666 0M8 10.57c-2.667 0-3.162 3-3.162 3h6.324s-.495-3-3.162-3"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M7.5 2.57H3.833c-.736 0-1.333.597-1.333 1.333v8.333c0 .737.597 1.334 1.333 1.334h1.005m8.662-5v3.666c0 .737-.597 1.334-1.333 1.334h-1.005m-6.324 0h6.324m-6.324 0s.495-3 3.162-3 3.162 3 3.162 3m1.505-12.334.722 1.445 1.444.722-1.444.722-.722 1.445-.723-1.445-1.444-.722 1.444-.722zM9.833 7.07a1.833 1.833 0 1 1-3.666 0 1.833 1.833 0 0 1 3.666 0"
        />
      </g>
      <defs>
        <clipPath id="a">
          <path fill="currentColor" d="M0 .07h16v16H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}
const ForwardRef = forwardRef(SvgUserStarred);
export default ForwardRef;
